import { GET_LIST_ACARA_SATKER, GET_DETAIL_ACARA_SATKER } from "shared/constants/ActionTypes";

const initialState = {
    listAcara: null,
    detail: null,
}

const kalenderSatkerReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LIST_ACARA_SATKER:
            return {
                ...state,
                listAcara: action.payload
            }
        case GET_DETAIL_ACARA_SATKER:
            return {
                ...state,
                detail: action.payload
            }
        default:
            return state;
    }
}

export default kalenderSatkerReducer